import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import { message } from "antd";
import { MultiPostRequest } from "../utils/APICall";

const SendReportForm = () => {
  const [file, setFile] = useState(null);
  const [loading, setloading] = useState(false);

  const fileInputRef = useRef(null);

  const formik = useFormik({
    initialValues: {
      // hrName: "Abdul Moiz",
      email: "",
      reportType: "",
      description: "",
    },
    onSubmit: async (values, { resetForm }) => {

      if (!file) {
        message.error("Please upload a report file.");
        return;
      }

      const formData = new FormData();
      for (let key in values) {
        formData.append(key, values[key]);
      }
      formData.append("reportFile", file);

      try {
        setloading(true)
        const response = await MultiPostRequest("sendReportEmp", formData);
        // console.log("response-->>>", response)
        if (response.status) {
          setFile(null);
          setloading(false)
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          message.success(response?.message);
          resetForm();

        }
        setloading(false)

      } catch (error) {
        setloading(false)
        message.error("Failed to send report.");
        console.error(error);
      }
    },
  });

  return (
    <div className="max-w-xl mx-auto bg-white dark:bg-gray-900 dark:text-white p-6 rounded-lg shadow-lg mt-10 ">
      <h2 className="text-2xl font-bold text-center mb-6">Send Report to Employee</h2>
      <form
        onSubmit={formik.handleSubmit}
        className="space-y-5 bg-white dark:bg-gray-900 p-6 rounded-lg"
        encType="multipart/form-data"
      >
        {/* Employee Email */}
        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
            Employee Email
          </label>
          <input
            type="email"
            name="email"
            placeholder="Employee Email"
            value={formik.values.email}
            onChange={formik.handleChange}
            required
            className="w-full border border-gray-300 dark:border-gray-700 
      bg-white dark:bg-gray-800 
      text-gray-900 dark:text-gray-100 
      rounded px-3 py-2 
      focus:outline-none focus:ring-2 
      focus:ring-blue-500 dark:focus:ring-blue-400"
          />
        </div>

        {/* Report Type */}
        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
            Report Type
          </label>
          <select
            name="reportType"
            value={formik.values.reportType}
            onChange={formik.handleChange}
            required
            className="w-full border border-gray-300 dark:border-gray-700 
      bg-white dark:bg-gray-800 
      text-gray-900 dark:text-gray-100 
      rounded px-3 py-2 
      focus:outline-none focus:ring-2 
      focus:ring-blue-500 dark:focus:ring-blue-400"
          >
            <option value="" disabled>Select Report Type</option>
            <option value="Attendance Report">Attendance Report</option>
            <option value="Early Exit Report">Early Exit Report</option>
            <option value="Late Attendence Report">Late Attendence Report</option>
            <option value="Leave Report">Leave Report</option>
            <option value="Monthly Report">Monthly Report</option>
            <option value="Report">Report</option>
          </select>
        </div>

        {/* Message */}
        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
            Message (optional)
          </label>
          <textarea
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            rows={4}
            placeholder="Add any additional comments"
            className="w-full border border-gray-300 dark:border-gray-700 
      bg-white dark:bg-gray-800 
      text-gray-900 dark:text-gray-100 
      rounded px-3 py-2 
      focus:outline-none focus:ring-2 
      focus:ring-blue-500 dark:focus:ring-blue-400"
          />
        </div>

        {/* File Upload */}
        <div>
          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
            Upload Report File (.pdf, .xlsx, .xls)
          </label>
          <input
            type="file"
            name="reportFile"
            accept=".pdf,.xlsx,.xls"
            required
            ref={fileInputRef}
            onChange={(e) => setFile(e.target.files[0])}
            className="w-full border border-gray-300 dark:border-gray-700 
      bg-white dark:bg-gray-800 
      text-gray-900 dark:text-gray-100 
      rounded px-3 py-2 
      file:mr-4 file:py-2 file:px-4 
      file:rounded file:border-0 
      file:text-sm file:font-semibold 
      file:bg-blue-100 dark:file:bg-gray-700 
      file:text-blue-700 dark:file:text-blue-300 
      hover:file:bg-blue-200 dark:hover:file:bg-gray-600"
          />
        </div>

        {/* Submit Button */}
        <div className="text-center">
          <button
            type="submit"
            disabled={loading}
            className={`px-6 py-2 rounded font-semibold transition duration-300
        ${loading
                ? "bg-gray-500 dark:bg-gray-600 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600"
              }
        text-white`}
          >
            {loading ? "Loading..." : "Send Report"}
          </button>
        </div>
      </form>

    </div>
  );
};

export default SendReportForm;
